<template>
  <div>
    <v-toolbar flat color="transparent">
      <div style="width: 350px" class="mx-2 my-6">
        <custom-text-field
          label="Buscar..."
          append-icon="mdi-magnify"
          clearable
          @keyup="buscar"
          @click:clear="limpiarBuscadorTexto">
        </custom-text-field>
      </div>
      <v-spacer></v-spacer>
      <!-- Boton para exportar Zip Documentos Relacionados -->
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <custom-button
            class="mx-2"
            label="Descargar Archivos"
            iconText="mdi-cloud-download"
            tipo="agregar"
            v-bind="attrs"
            v-on="on"
            :loading="estaCargando"
            @click="exportar">
          </custom-button>
        </template>
        <span >Descargar Archivos</span>
      </v-tooltip>
      <!-- Boton para agregar documento a expediente -->
      <custom-button
        label="Agregar Archivo"
        iconText="mdi-plus"
        tipo="agregar"
        @click="agregarDocumentoRelacionado">
      </custom-button>
    </v-toolbar>
  </div>
</template>

<script>
import CustomTextField from '@/components/inputs/sinColumnas/TextField.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'DocumentosRelacionadosToolBar',
  props: {
    estaCargando: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      buscarTexto: null,
      debounce: null,
    };
  },
  components: {
    CustomTextField,
    CustomButton,
  },
  methods: {
    buscar(e) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.buscarTexto = e.target.value;
      }, 600);
    },
    limpiarBuscadorTexto() {
      this.buscarTexto = '';
    },
    exportar() {
      this.$emit('expotarDocumentos');
    },
    agregarDocumentoRelacionado() {
      this.$emit('agregarDocumentoRelacionado');
    },
  },
  watch: {
    buscarTexto: {
      handler() {
        this.$emit('buscar', this.buscarTexto);
      },
    },
  },
};
</script>

<style lang="scss">

</style>
